import T2 from "./T2";
import { Routes, Route, Link } from "react-router-dom";
function WomenDays() {
    return (

        <Routes>
            <Route path="/" element={<T2 />}>
                <Route path="t2/:slug" element={<T2 />} />
            </Route>
        </Routes>
    )
}
export default WomenDays;